import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-c58e7e08"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  key: "timeout",
  class: "timeout-container"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h3", {
    class: "title"
  }, "检测超时", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc"
  }, [/*#__PURE__*/_createTextVNode(" 检测时间超过"), /*#__PURE__*/_createElementVNode("span", {
    class: "hl"
  }, "3分钟"), /*#__PURE__*/_createTextVNode("，请重新检测 ")], -1);
});
var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 重新检测 ");
var _hoisted_6 = {
  key: "fail",
  class: "fail-container"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h3", {
    class: "title"
  }, "检测结束", -1);
});
var _hoisted_8 = {
  class: "desc"
};
var _hoisted_9 = {
  key: 0,
  class: "desc-line"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "desc-text"
  }, "请使用最新版本的谷歌浏览器", -1);
});
var _hoisted_11 = /*#__PURE__*/_createTextVNode("下载谷歌浏览器");
var _hoisted_12 = {
  key: 1,
  class: "desc-line"
};
var _hoisted_13 = {
  class: "desc-text"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc-tip"
  }, " 注：请按提示进行考前检测，可能影响最终考试成绩。 ", -1);
});
var _hoisted_15 = {
  key: "success",
  class: "success-container"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h3", {
    class: "title"
  }, "检测完成", -1);
});
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc"
  }, " 答题时，请使用最新版本的谷歌浏览器，并打开摄像头和麦克风哦！~ ", -1);
});
var _hoisted_18 = /*#__PURE__*/_createTextVNode(" 确认 ");
var _hoisted_19 = /*#__PURE__*/_createTextVNode(" 确认 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_button = _resolveComponent("a-button");
  var _component_ExclamationCircleFilled = _resolveComponent("ExclamationCircleFilled");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.envCheckService.timeout ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createVNode(_component_a_button, {
    type: "primary",
    size: "large",
    shape: "round",
    onClick: _ctx.envCheckService.reset
  }, {
    default: _withCtx(function () {
      return [_hoisted_5];
    }),
    _: 1
  }, 8, ["onClick"])])) : _ctx.envCheckService.isBrowserNotValid || _ctx.envCheckService.isVideoError ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_ctx.envCheckService.isBrowserNotValid ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_ExclamationCircleFilled, {
    style: {
      "color": "red",
      "font-size": "18px"
    }
  }), _hoisted_10, _createVNode(_component_a_button, {
    class: "desc-button",
    type: "primary",
    shape: "round",
    onClick: _ctx.downloadChrome
  }, {
    default: _withCtx(function () {
      return [_hoisted_11];
    }),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), _ctx.envCheckService.isVideoError && !_ctx.envCheckService.isNotSupportMediaRecorder ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_ExclamationCircleFilled, {
    style: {
      "color": "red",
      "font-size": "18px"
    }
  }), _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.envCheckService.isVideoNotAllowed ? '请使用谷歌浏览器，点击设置->隐私设置和安全性->权限->打开摄像头/麦克风' : '请更换摄像头和麦克风设备'), 1)])) : _createCommentVNode("", true)]), _hoisted_14])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _hoisted_17, _ctx.isNocFlag ? (_openBlock(), _createBlock(_component_a_button, {
    key: 0,
    type: "primary",
    size: "large",
    shape: "round",
    href: "/user?platform=noc"
  }, {
    default: _withCtx(function () {
      return [_hoisted_18];
    }),
    _: 1
  })) : (_openBlock(), _createBlock(_component_a_button, {
    key: 1,
    type: "primary",
    size: "large",
    shape: "round",
    href: "/user"
  }, {
    default: _withCtx(function () {
      return [_hoisted_19];
    }),
    _: 1
  }))]))]);
}